// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oneline-input--grid {
  padding: 10.5px;
}

.business-processes-constructor-card .business-processes-constructor-card__row {
  height: 58px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/ProcessingWorkOrdersConstructor.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".oneline-input--grid {\n  padding: 10.5px;\n}\n\n.business-processes-constructor-card .business-processes-constructor-card__row {\n  height: 58px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
